import FooterDesktop from "./FooterDesktop";

export default FooterDesktop;
